import {
  Artist,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";

export const isModelTypeGuard = (
  modelMaybe: Artist | Instrument | ModelNoDates | MixedModelConstructedNoDates
): modelMaybe is ModelNoDates => {
  return "presignedUrlModel" in modelMaybe;
};
